import {storeToRefs} from 'pinia';
import {useProfileSuggestionsStore} from '~/features/profile-suggestions/store/profile-suggestions.store';
import {useTaskListStore} from '~/features/task-list/store/task-list.store';

export function useProfileSuggestionsVisibility() {
    const suggestionsStore = useProfileSuggestionsStore();
    const {taskListCompleted} = storeToRefs(suggestionsStore);
    const showTaskList = !taskListCompleted.value || useTaskListStore().hasPendingConfetti();
    const showSuggestionsSection = suggestionsStore.shouldShowSuggestionsSection();
    return {showTaskList, showSuggestionsSection};
}
